export default __webpack_public_path__ + "static/media/mang.d3c0cef7.png";